import { useState } from "react";

import "./messagingWindow.css";

// Import children components to render.
import Conversation from "../components/conversation";

export default function MessagingWindow(props) {
    let [uiReady, setUIReady] = useState(false);
    // AWAC: true while the gallery wing is open. Drives the horizontal expansion.
    let [galleryActive, setGalleryActive] = useState(false);

    /**
     * Sets the app's ui ready status based on the communication from the child Conversation component..
     * Propogates the same upto the parent BootstrapMessaging component for Messaging Button reactive ui updates.
     * @param {boolean}
     */
    function setAppUIReady(isUIReady) {
        setUIReady(isUIReady);
        props.deactivateMessagingButton(isUIReady);
    }

    /**
     * Generates a classname for the parent div that holds the messaging window ui.
     * Hides the parent div if the app is not ui ready.
     * @returns {string}
     */
    function generateMessagingWindowClassName() {
        const className = "messagingWindow";

        // AWAC: when the gallery wing is open, the widget expands horizontally
        // into a two-column layout (chat + gallery) inside ONE container.
        return className
            + `${uiReady ? "" : " hide"}`
            + `${props.isMinimized ? " awacMinimized" : ""}`
            + `${galleryActive ? " awacExpanded" : ""}`;
    }

    return(
        <div className={generateMessagingWindowClassName()} aria-hidden={props.isMinimized ? "true" : "false"}>
            <Conversation
                isExistingConversation={props.isExistingConversation}
                showMessagingWindow={props.showMessagingWindow}
                minimizeMessagingWindow={props.minimizeMessagingWindow}
                onGalleryActiveChange={setGalleryActive}
                uiReady={setAppUIReady} />
        </div>
    );
}